module.exports = __webpack_public_path__ + "static/media/shingan_merit_pc.2d812172.png";